// R2 (ARCFE-985): the read half of the `selectedOrganizationIdAtom` row
// retirement — reads through this hook, writes through the
// `setSelectedOrganizationId` command.
import { useAtomValue } from 'jotai';

import { selectedOrganizationIdAtom } from '../atoms/organizationAtoms';

export function useSelectedOrganizationId(): string | null {
  return useAtomValue(selectedOrganizationIdAtom);
}
